const LoaderMixin = {
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    Loading(booleand) {
      this.loading = booleand;
    },
  },
  updated() {
    this.Loading(false);
  },
};

export default LoaderMixin;
